import { Routes } from '@angular/router';

import { getFeatureToggle } from '../shared/feature-toggle';
import { MainUserRegisterV2Component } from './containers/main-user-register-v2/main-user-register-v2.component';
import { UserRegisterComponent } from './user-register.component';

export const userRegisterRoutes: Routes = [
  {
    path: 'user-register/:userId/:token',
    component: MainUserRegisterV2Component,
    canMatch: [(): boolean => getFeatureToggle().userRegisterV2],
  },
  {
    path: 'user-register/:userId/:token',
    component: UserRegisterComponent,
  },
];
